import {
  Component,
  computed,
  EventEmitter,
  input,
  Output,
} from '@angular/core';
import {
  ActionEvent,
  StandardAction,
  StandardActionBuilder,
} from '@infodata-group/inf-commons';
import { TranslateModule } from '@ngx-translate/core';

const POI = new StandardActionBuilder('POI', 'map-marker')
  .setText('Ajouter un POI')
  .build();

@Component({
  selector: 'ao-shared-map-dropdown',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './map-dropdown.component.html',
  styleUrl: './map-dropdown.component.scss',
})
export class MapDropdownComponent {
  public isOpen = input.required<boolean>();
  public layerX = input.required<number>();
  public layerY = input.required<number>();
  public actions = input.required<StandardAction[]>();

  @Output() clickAction = new EventEmitter<ActionEvent>();

  private height = computed(() => {
    return this.actions().length * 40;
  });
  protected style = computed(() => {
    return {
      height: `${this.height}px`,
      top: `${this.layerY()}px`,
      left: `${this.layerX()}px`,
    };
  });

  protected onClickAction($event: StandardAction): void {
    this.clickAction.emit(new ActionEvent('click', $event));
  }
}
